/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Users_Credits_GrantedInputs */

const en_admin_users_credits_granted = /** @type {(inputs: Admin_Users_Credits_GrantedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credits granted`)
};

const zh_admin_users_credits_granted = /** @type {(inputs: Admin_Users_Credits_GrantedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`积分已授予`)
};

/**
* | output |
* | --- |
* | "Credits granted" |
*
* @param {Admin_Users_Credits_GrantedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_users_credits_granted = /** @type {((inputs?: Admin_Users_Credits_GrantedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Users_Credits_GrantedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_users_credits_granted(inputs)
	return zh_admin_users_credits_granted(inputs)
});
export { admin_users_credits_granted as "admin.users.credits_granted" }